define(['jquery', 'jquery.transit', 'modernizr', 'container', 'underscore', 'jump', 'slider-carousel-infinite-enhanced', 'lightbox', 'preloader', 'back-top'],
    function ($, transit, modernizr, container, _, jumpFactory, sliderCarouselInfiniteEnhancedFactory, lightboxFactory, preloader, backTopFactory) {

        return (function () {

            const name = 'tv-schedule';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const pubSub = container.getPublishSubscribe();
            const slider = sliderCarouselInfiniteEnhancedFactory.create();
            const jump = jumpFactory.create();
            const lightbox = lightboxFactory.create();
            const backTop = backTopFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {
                getScheduleForDate: function (day,month,year) {

                    const url = model.publicVars.ajaxNewScheduleEndpoint + '/' + year + '/' + month + '/' + day;

                    $.ajax({
                        url: url,
                        type: 'GET',
                        data: {}
                    }).done(function (data) {
                        pubSub.publish('view/actionShowNewTvSchedule', data);
                    });
                },
            };

            /* view */

            view.publicVars = {};

            view.privateVars = {
                loading: true,
                changeSizeLoadingInterval: '',
                changeSizeLoadingWidth: 0,
                changeSizeLoading: false,
                calculatingItemsFlag: false,
                items: {},
                oneLineWordNumber: 5,
                twoLinesWordNumber: 10,
                calendar: {
                    loading: false
                },
                window: {
                    windowWidth: 0,
                    windowHeight: 0
                },
                currentTimeStamp: Date.now()
            };

            view.startup = function () {

                preloader.setPreloadBulk('tv-schedule', view.publicVars.preloadTab);

                view.methods.calculateWindowWidthHeight();

                view.privateVars.changeSizeLoadingWidth = view.privateVars.window.windowWidth;

                view.privateVars.currentItem = view.publicVars.currentItem;

                container.msg(name + ': startup t ' + view.privateVars.currentTimeStamp);

                view.methods.calculateLineWordNumbers();
                view.methods.recalculateOpenState();

            };

            view.bind = function () {
                $(view.publicVars.cssId.tvItemListInnerCls).on('click', view.publicVars.cssId.tvItemInnerCls, function () {
                    view.methods.handleItemOpen(this);
                });

                $(window).resize(function() {
                    view.methods.calculateWindowWidthHeight();
                    view.methods.calendar.handleLightboxState();
                    view.methods.calculateLineWordNumbers();
                    if(view.privateVars.changeSizeLoadingWidth !== view.privateVars.window.windowWidth) {
                        view.methods.recalculateResizeOpenStateWrapper();
                    }
                });

                $(window).on("orientationchange", function() {
                    view.methods.calculateWindowWidthHeight();
                    view.methods.calendar.handleLightboxState();
                    view.methods.calculateLineWordNumbers();
                    if(view.privateVars.changeSizeLoadingWidth !== view.privateVars.window.windowWidth) {
                        view.methods.recalculateResizeOpenStateWrapper();
                    }
                });

                $(view.publicVars.cssId.dayTimeSelectorItem).click(function () {
                    const targetCls = container.getData($(this)[0], 'target.cls');

                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();

                    let speed = 300;

                    if(targetCls === 'is-afternoon') {
                        speed = 700;
                    } else if(targetCls === 'is-evening') {
                        speed = 1100;
                    } else if(targetCls === 'is-night') {
                        speed = 1500;
                    }

                    if($(view.publicVars.cssId.tvItemCls + '.' + targetCls).length > 0) {
                        jump.jumpTo(view.publicVars.cssId.tvItemCls + '.' + targetCls, {
                            speed: speed,
                            modifier: -parseInt(headerHeight),
                            easing: 'swing'
                        });
                    }
                });

                $(view.publicVars.cssId.calendar.weekCarouselIconsCalendar).click(function () {
                    $('html').addClass(view.publicVars.cssId.calendar.calendarLightboxOpenCls.substr(1));

                    lightbox.showLayer(() => {

                    });
                });

                $(view.publicVars.cssId.calendar.canHoverCls + view.publicVars.cssId.calendar.calendarLightboxItemCls).click(function () {
                    if(!view.privateVars.loading) {
                        view.privateVars.loading = true;
                        view.methods.calendar.handleDayChosed(this);
                    }
                });

                $(view.publicVars.cssId.weekCarousel.weekCarouselItemCls).click(function () {
                    if(!view.privateVars.loading) {
                        view.privateVars.loading = true;
                        view.methods.weekCarousel.handleDayChosed(this);
                    }
                });
            };

            view.methods = {
                handleItemOpen: (handler) => {
                    const id = container.getData($(handler)[0], 'id');

                    if(view.privateVars.items[id].full || view.privateVars.items[id].openLoading) {
                        return;
                    }

                    view.privateVars.items[id].openLoading = true;

                    if($(handler).hasClass(view.publicVars.cssId.isOpenedCls.substr(1))) {
                        $(handler).removeClass(view.publicVars.cssId.isOpenedCls.substr(1));

                        const oldHtml = $(view.publicVars.cssId.tvItemContentCls, handler).html();
                        $(view.publicVars.cssId.tvItemContentCls, handler).html(view.privateVars.items[id].shortItem);

                        const newHeight = $(handler).outerHeight();

                        $(view.publicVars.cssId.tvItemContentCls, handler).html(oldHtml);

                        $(view.publicVars.cssId.tvItemInnerWrapperCls, handler).css({
                            height: $(handler).outerHeight(),
                            overflow: 'hidden'
                        });

                        $(view.publicVars.cssId.tvItemInnerWrapperCls, handler).transit({height: newHeight + 'px'}, 300, function () {
                            $(view.publicVars.cssId.tvItemInnerWrapperCls, handler).removeAttr('style');
                            view.privateVars.items[id].openLoading = false;
                        });

                        $(view.publicVars.cssId.tvItemContentCls, handler).html(view.privateVars.items[id].shortItem);

                    } else {
                        $(handler).addClass(view.publicVars.cssId.isOpenedCls.substr(1));

                        const oldHtml = $(view.publicVars.cssId.tvItemContentCls, handler).html();

                        $(view.publicVars.cssId.tvItemContentCls, handler).html(view.privateVars.items[id].originalItem);

                        const newHeight = $(handler).outerHeight();

                        $(view.publicVars.cssId.tvItemContentCls, handler).html(oldHtml);

                        $(view.publicVars.cssId.tvItemInnerWrapperCls, handler).css({
                            height: $(handler).outerHeight(),
                            overflow: 'hidden'
                        });
                        $(view.publicVars.cssId.tvItemInnerWrapperCls, handler).transit({height: newHeight + 'px'}, 300, function () {
                            $(view.publicVars.cssId.tvItemInnerWrapperCls, handler).removeAttr('style');
                            view.privateVars.items[id].openLoading = false;
                        });

                        $(view.publicVars.cssId.tvItemContentCls, handler).html(view.privateVars.items[id].originalItem);
                    }
                },

                recalculateResizeOpenStateWrapper: () => {

                    const width = view.privateVars.window.windowWidth;
                    if(!view.privateVars.changeSizeLoading && !view.privateVars.loading) {
                        view.methods.recalculateResizeOpenState();
                    }

                    if(width !== view.privateVars.changeSizeLoadingWidth) {
                        view.privateVars.changeSizeLoadingWidth = width;
                        view.privateVars.changeSizeLoading = true;
                        view.privateVars.loading = true;
                        clearInterval(view.privateVars.changeSizeLoadingInterval);
                        view.privateVars.changeSizeLoadingInterval = setTimeout(function () {
                            view.privateVars.changeSizeLoading = false;
                            //clearInterval(view.privateVars.changeSizeLoadingInterval);

                            $(view.publicVars.cssId.tvItemInnerCls).each(function (key, item) {
                                const itemId = container.getData($(item)[0], 'id');

                                $(view.publicVars.cssId.tvItemContentCls, item).html(view.privateVars.items[itemId].originalItem);
                            });

                            $(view.publicVars.cssId.tvItemInnerCls).removeClass(view.publicVars.cssId.isOpenedCls.substr(1));

                            view.methods.recalculateOpenState(width);
                        }, 500);
                    }
                },

                recalculateResizeOpenState: () => {

                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();

                    $(view.publicVars.cssId.tvItemListInnerCls).css({ opacity: 0});

                    $(view.publicVars.cssId.tvItemListGuardCls).css({ visibility: 'visible' });

                    $(view.publicVars.cssId.tvItemListContainerCls).css({ height: '450px', overflow: 'hidden'});

                    $(view.publicVars.cssId.tvItemListLoaderId).css({opacity: 0, display: 'block'});
                    $(view.publicVars.cssId.tvItemListLoaderId).transit({opacity: 1});

                    backTop.disable();

                    jump.centerTo(view.publicVars.cssId.tvItemListLoaderId, () => {

                    }, {
                        speed: 0,
                        modifier: - parseInt(headerHeight)
                    });

                    setTimeout(function () {
                        jump.centerTo(view.publicVars.cssId.tvItemListLoaderId, () => {

                        }, {
                            speed: 300,
                            modifier: - parseInt(headerHeight)
                        });
                    }, 100);
                },

                recalculateOpenState: (width) => {

                    container.msg(name + ': recalculate t ' + (Date.now() - view.privateVars.currentTimeStamp));

                    if(view.privateVars.changeSizeLoading) {
                        return;
                    }

                    if(width && width !== view.privateVars.changeSizeLoadingWidth) {
                        return;
                    }

                    $(view.publicVars.cssId.tvItemFakeTxtCls).css({ display: 'block'});
                    const baseTxtHeight = $(view.publicVars.cssId.tvItemFakeTxtCls).outerHeight();
                    $(view.publicVars.cssId.tvItemFakeTxtCls).css({ display: 'none'});

                    container.msg(name + ' - base txt height ' + baseTxtHeight);

                    const tvItemsCollectionArray = $(view.publicVars.cssId.tvItemInnerCls).toArray();

                    view.methods.calculateItemHelper(tvItemsCollectionArray, baseTxtHeight, width);

                    // $(view.publicVars.cssId.tvItemInnerCls).each(function (key, item) {
                    //     const tvItemContentClsHandler = $(view.publicVars.cssId.tvItemContentCls, item);
                    //     const tvItemContentDescClsHandler = $(view.publicVars.cssId.tvItemContentDescCls, item);
                    //
                    //     const itemId = container.getData($(item)[0], 'id');
                    //     const itemDesc = tvItemContentDescClsHandler.html();
                    //     const itemPrize = $(view.publicVars.cssId.tvItemContentPrizeCls, item).html();
                    //
                    //     view.privateVars.items[itemId] = {
                    //         id: itemId,
                    //         descExist: tvItemContentDescClsHandler.length > 0,
                    //         prizeExist: $(view.publicVars.cssId.tvItemContentPrizeCls, item).length > 0,
                    //         desc: itemDesc,
                    //         prize: itemPrize
                    //     };
                    //
                    //     $(view.publicVars.cssId.tvItemListInnerCls).css({ display: 'block', visiblity: 'hidden', opacity: 0});
                    //
                    //     const itemOriginalHeight = tvItemContentClsHandler.outerHeight();
                    //     const availableHeightSpace = $(view.publicVars.cssId.tvItemImageCls, item).outerHeight();
                    //
                    //     view.privateVars.items[itemId].originalHeight = itemOriginalHeight;
                    //     view.privateVars.items[itemId].originalItem = $.trim(tvItemContentClsHandler.html());
                    //     view.privateVars.items[itemId].full = false;
                    //     view.privateVars.items[itemId].openLoading = false;
                    //
                    //     //item can be displayed in full - enough space
                    //     if(availableHeightSpace >= itemOriginalHeight) {
                    //         $(view.publicVars.cssId.tvItemVArrowCls, item).css({ display: 'none'});
                    //         $(item).removeClass(view.publicVars.cssId.canHoverCls.substr(1));
                    //
                    //         view.privateVars.items[itemId].showDesc = true;
                    //         view.privateVars.items[itemId].showFullDesc = true;
                    //         view.privateVars.items[itemId].showPrize = true;
                    //         view.privateVars.items[itemId].showFullPrize = true;
                    //         view.privateVars.items[itemId].showReleaseYear = true;
                    //         view.privateVars.items[itemId].showBtn = true;
                    //         view.privateVars.items[itemId].full = true;
                    //
                    //         return;
                    //     } else {
                    //
                    //         $(view.publicVars.cssId.tvItemVArrowCls, item).css({ display: 'block'});
                    //
                    //         const prizeModuleExist = $(view.publicVars.cssId.tvItemContentPrizeCls, item).length > 0;
                    //         const descModuleExist = tvItemContentDescClsHandler.length > 0;
                    //         const releaseYearModuleExist = $(view.publicVars.cssId.tvItemContentReleaseYearCls, item).length > 0;
                    //         const btnModuleExist = $(view.publicVars.cssId.tvItemContentBtnCls, item).length > 0;
                    //
                    //         view.privateVars.items[itemId].showDesc = false;
                    //         view.privateVars.items[itemId].showFullDesc = false;
                    //         view.privateVars.items[itemId].showPrize = false;
                    //         view.privateVars.items[itemId].showFullPrize = false;
                    //         view.privateVars.items[itemId].showReleaseYear = false;
                    //         view.privateVars.items[itemId].showBtn = false;
                    //         view.privateVars.items[itemId].full = false;
                    //
                    //         //hide additional module and check if they can be shown
                    //         tvItemContentDescClsHandler.css({ display: 'none'});
                    //         $(view.publicVars.cssId.tvItemContentPrizeCls, item).css({ display: 'none'});
                    //         $(view.publicVars.cssId.tvItemContentReleaseYearCls, item).css({ display: 'none'});
                    //         $(view.publicVars.cssId.tvItemContentBtnCls, item).css({ display: 'none'});
                    //
                    //         const itemBaseHeight = tvItemContentClsHandler.outerHeight();
                    //
                    //         // container.msg(name + ' - item base height: ' + (itemBaseHeight));
                    //         // container.msg(name + ' - new space available: ' + (availableHeightSpace - itemBaseHeight ));
                    //
                    //         //if module or prize are available check what can be displayed
                    //         if(descModuleExist || prizeModuleExist) {
                    //             view.methods.getCorrectDescPrizeHeight(item, prizeModuleExist, descModuleExist,
                    //                 baseTxtHeight, availableHeightSpace);
                    //         }
                    //
                    //         if(releaseYearModuleExist) {
                    //             $(view.publicVars.cssId.tvItemContentReleaseYearCls, item).css({ display: 'block'});
                    //
                    //             view.privateVars.items[itemId].showReleaseYear = true;
                    //
                    //             if(availableHeightSpace < tvItemContentClsHandler.outerHeight()) {
                    //                 $(view.publicVars.cssId.tvItemContentReleaseYearCls, item).css({ display: 'none'});
                    //
                    //                 view.privateVars.items[itemId].showReleaseYear = false;
                    //             }
                    //         }
                    //
                    //         if(btnModuleExist) {
                    //             $(view.publicVars.cssId.tvItemContentBtnCls, item).css({ display: 'block'});
                    //
                    //             view.privateVars.items[itemId].showBtn = true;
                    //
                    //             if(availableHeightSpace < $(view.publicVars.cssId.tvItemContentBtnCls, item).outerHeight()) {
                    //                 $(view.publicVars.cssId.tvItemContentBtnCls, item).css({ display: 'none'});
                    //
                    //                 view.privateVars.items[itemId].showBtn = false;
                    //             }
                    //         }
                    //     }
                    //
                    //     view.privateVars.items[itemId].shortItem = $.trim(tvItemContentClsHandler.html());
                    //     view.privateVars.items[itemId].shortItemHeight = tvItemContentClsHandler.outerHeight();
                    //
                    //     $(view.publicVars.cssId.tvItemListInnerCls).css({ display: 'none', visiblity: 'visible', opacity: 1});
                    //
                    //
                    // });


                    // setTimeout(() => {
                        const calculatingItemsInterval = setInterval(function () {
                            if(view.privateVars.calculatingItemsFlag) {
                                clearInterval(calculatingItemsInterval);

                                container.msg(name + ': calculated t ' + (Date.now() - view.privateVars.currentTimeStamp));
                                view.methods.showTvSchedule();
                            }
                        }, 100);
                    // }, 0);

                },

                calculateItemHelper: (tvItemsCollectionArray, baseTxtHeight, width) => {

                    if(width && width !== view.privateVars.changeSizeLoadingWidth) {
                        return;
                    }

                    if(tvItemsCollectionArray.length === 0) {
                        view.privateVars.calculatingItemsFlag = true;
                        return;
                    }

                    const item = tvItemsCollectionArray.pop();
                    const tvItemContentClsHandler = $(view.publicVars.cssId.tvItemContentCls, item);
                    const tvItemContentDescClsHandler = $(view.publicVars.cssId.tvItemContentDescCls, item);
                    const tvItemListInnerClsHandler = $(view.publicVars.cssId.tvItemListInnerCls);
                    const tvItemContentBtnClsHandler = $(view.publicVars.cssId.tvItemContentBtnCls, item);
                    const tvItemContentPrizeClsHandler = $(view.publicVars.cssId.tvItemContentPrizeCls, item);
                    const tvItemImageClsHandler = $(view.publicVars.cssId.tvItemImageCls, item);
                    const tvItemVArrowClsHandler = $(view.publicVars.cssId.tvItemVArrowCls, item);
                    const tvItemContentReleaseYearClsHandler = $(view.publicVars.cssId.tvItemContentReleaseYearCls, item);

                    const itemId = container.getData($(item)[0], 'id');
                    const itemDesc = tvItemContentDescClsHandler.html();
                    const itemPrize = tvItemContentPrizeClsHandler.html();

                    view.privateVars.items[itemId] = {
                        id: itemId,
                        descExist: tvItemContentDescClsHandler.length > 0,
                        prizeExist: tvItemContentPrizeClsHandler.length > 0,
                        desc: itemDesc,
                        prize: itemPrize
                    };

                    tvItemListInnerClsHandler.css({ display: 'block', visiblity: 'hidden', opacity: 0});

                    const itemOriginalHeight = tvItemContentClsHandler.outerHeight();
                    const availableHeightSpace = tvItemImageClsHandler.outerHeight();

                    view.privateVars.items[itemId].originalHeight = itemOriginalHeight;
                    view.privateVars.items[itemId].originalItem = $.trim(tvItemContentClsHandler.html());
                    view.privateVars.items[itemId].full = false;
                    view.privateVars.items[itemId].openLoading = false;

                    //item can be displayed in full - enough space
                    if(availableHeightSpace >= itemOriginalHeight) {
                        tvItemVArrowClsHandler.css({ display: 'none'});
                        $(item).removeClass(view.publicVars.cssId.canHoverCls.substr(1));

                        view.privateVars.items[itemId].showDesc = true;
                        view.privateVars.items[itemId].showFullDesc = true;
                        view.privateVars.items[itemId].showPrize = true;
                        view.privateVars.items[itemId].showFullPrize = true;
                        view.privateVars.items[itemId].showReleaseYear = true;
                        view.privateVars.items[itemId].showBtn = true;
                        view.privateVars.items[itemId].full = true;
                    } else {

                        tvItemVArrowClsHandler.css({ display: 'block'});

                        const prizeModuleExist = tvItemContentPrizeClsHandler.length > 0;
                        const descModuleExist = tvItemContentDescClsHandler.length > 0;
                        const releaseYearModuleExist = tvItemContentReleaseYearClsHandler.length > 0;
                        const btnModuleExist = tvItemContentBtnClsHandler.length > 0;

                        view.privateVars.items[itemId].showDesc = false;
                        view.privateVars.items[itemId].showFullDesc = false;
                        view.privateVars.items[itemId].showPrize = false;
                        view.privateVars.items[itemId].showFullPrize = false;
                        view.privateVars.items[itemId].showReleaseYear = false;
                        view.privateVars.items[itemId].showBtn = false;
                        view.privateVars.items[itemId].full = false;

                        //hide additional module and check if they can be shown
                        tvItemContentDescClsHandler.css({ display: 'none'});
                        tvItemContentPrizeClsHandler.css({ display: 'none'});
                        tvItemContentReleaseYearClsHandler.css({ display: 'none'});
                        tvItemContentBtnClsHandler.css({ display: 'none'});

                        // const itemBaseHeight = tvItemContentClsHandler.outerHeight();

                        // container.msg(name + ' - item base height: ' + (itemBaseHeight));
                        // container.msg(name + ' - new space available: ' + (availableHeightSpace - itemBaseHeight ));

                        //if module or prize are available check what can be displayed
                        if(descModuleExist || prizeModuleExist) {
                            view.methods.getCorrectDescPrizeHeight(item, prizeModuleExist, descModuleExist,
                                baseTxtHeight, availableHeightSpace);
                        }

                        if(releaseYearModuleExist) {
                            tvItemContentReleaseYearClsHandler.css({ display: 'block'});

                            view.privateVars.items[itemId].showReleaseYear = true;

                            if(availableHeightSpace < tvItemContentClsHandler.outerHeight()) {
                                tvItemContentReleaseYearClsHandler.css({ display: 'none'});

                                view.privateVars.items[itemId].showReleaseYear = false;
                            }
                        }

                        if(btnModuleExist) {
                            tvItemContentBtnClsHandler.css({ display: 'block'});

                            view.privateVars.items[itemId].showBtn = true;

                            if(availableHeightSpace < tvItemContentClsHandler.outerHeight()) {
                                tvItemContentBtnClsHandler.css({ display: 'none'});

                                view.privateVars.items[itemId].showBtn = false;
                            }
                        }
                    }

                    view.privateVars.items[itemId].shortItem = $.trim(tvItemContentClsHandler.html());
                    view.privateVars.items[itemId].shortItemHeight = tvItemContentClsHandler.outerHeight();

                    tvItemListInnerClsHandler.css({ display: 'none', visiblity: 'visible', opacity: 1});

                    // let timeoutTimer = 0;
                    //
                    // if($(window).width() > 1200) {
                    //     timeoutTimer = 0;
                    // }
                    //
                    // setTimeout(function () {
                        view.methods.calculateItemHelper(tvItemsCollectionArray, baseTxtHeight, width);
                    // }, timeoutTimer);
                },

                getCorrectDescPrizeHeight: (item, prizeModuleExist, descModuleExist, baseTxtHeight, availableHeightSpace) => {

                    const tvItemContentDescClsHandler = $(view.publicVars.cssId.tvItemContentDescCls, item);
                    const tvItemContentPrizeClsHandler = $(view.publicVars.cssId.tvItemContentPrizeCls, item);
                    const tvItemContentClsHandler = $(view.publicVars.cssId.tvItemContentCls, item);

                    const itemId = container.getData($(item)[0], 'id');

                    tvItemContentPrizeClsHandler.css({ display: 'block'});
                    tvItemContentDescClsHandler.css({ display: 'block'});

                    const itemPrizeDescHeight = tvItemContentClsHandler.outerHeight();

                    // container.msg(name + ' - item prize desc height: ' + (itemPrizeDescHeight));

                    //add dots to check height of items with dots
                    if(prizeModuleExist) {
                        tvItemContentPrizeClsHandler.html($.trim(tvItemContentPrizeClsHandler.html()) + '...');
                    }

                    if(descModuleExist) {
                        tvItemContentDescClsHandler.html($.trim(tvItemContentDescClsHandler.html()) + '...');
                    }

                    const prizeHeight = prizeModuleExist ? tvItemContentPrizeClsHandler.outerHeight() : 0;
                    const descHeight = descModuleExist ? tvItemContentDescClsHandler.outerHeight() : 0;

                    //if we have space to show full prize and desc
                    if(availableHeightSpace >= itemPrizeDescHeight) {

                        //if prize height and desc height have more than 2 lines
                        if((prizeHeight + descHeight).toFixed(2) > (baseTxtHeight * 2).toFixed(2)) {

                            let prizeLinesTaken = 0;

                            //there is a prize txt
                            if(prizeHeight > 0) {

                                //if prize txt takes more than 2 lines
                                if (prizeHeight.toFixed(2) >= (baseTxtHeight * 2).toFixed(2)) {
                                    prizeLinesTaken = 2;

                                    view.privateVars.items[itemId].showPrize = true;
                                    view.privateVars.items[itemId].showFullPrize = true;

                                    if(prizeHeight.toFixed(2) > (baseTxtHeight * 2).toFixed(2)) {
                                        //truncate prizeDesc to 2 lines height
                                        //and give ...
                                        view.methods.truncateTxtToLines(2, tvItemContentPrizeClsHandler.html(),
                                            view.publicVars.cssId.tvItemContentPrizeCls, baseTxtHeight, item);

                                        view.privateVars.items[itemId].showFullPrize = false;
                                    }

                                    //hide desc module prize is shown in full no place for desc
                                    if (descModuleExist) {
                                        tvItemContentDescClsHandler.css({display: 'none'});
                                        if(tvItemContentDescClsHandler.html().slice(-3) === '...') {
                                            tvItemContentDescClsHandler.html(tvItemContentDescClsHandler.html().slice(0, -3));
                                        }

                                        view.privateVars.items[itemId].showDesc = false;
                                        view.privateVars.items[itemId].showFullDesc = false;
                                    }
                                } else if (prizeHeight.toFixed(2) === baseTxtHeight.toFixed(2)) {
                                    //prize height equals 1 line
                                    prizeLinesTaken = 1;
                                    view.privateVars.items[itemId].showPrize = true;
                                    view.privateVars.items[itemId].showFullPrize = true;
                                }
                            }

                            //if there is a desc height and prize took less than two lines
                            if(descHeight > 0 && prizeLinesTaken < 2) {

                                //there is place for one line of desc
                                if (prizeLinesTaken === 1) {

                                    //there would be one line of desc - strip dots from prize
                                    if(tvItemContentPrizeClsHandler.html().slice(-3) === '...') {
                                        tvItemContentPrizeClsHandler.html(tvItemContentPrizeClsHandler.html().slice(0, -3));
                                    }

                                    view.privateVars.items[itemId].showDesc = true;
                                    view.privateVars.items[itemId].showFullDesc = true;

                                    //desc takes more than one line - needs to be truncated
                                    if(descHeight.toFixed(2) > baseTxtHeight.toFixed(2)) {
                                        view.methods.truncateTxtToLines(1, tvItemContentDescClsHandler.html(),
                                            view.publicVars.cssId.tvItemContentDescCls, baseTxtHeight, item);

                                        view.privateVars.items[itemId].showFullDesc = false;
                                    }
                                } else {
                                    //there is no prize txt so we have 2 lines for desc
                                    view.privateVars.items[itemId].showDesc = true;
                                    view.privateVars.items[itemId].showFullDesc = true;

                                    //desc txt is more than 2 lines needs to be truncated to 2 lines
                                    if(descHeight.toFixed(2) > (baseTxtHeight * 2).toFixed(2)) {
                                        view.methods.truncateTxtToLines(2, tvItemContentDescClsHandler.html(),
                                            view.publicVars.cssId.tvItemContentDescCls, baseTxtHeight, item);

                                        view.privateVars.items[itemId].showFullDesc = false;
                                    }
                                }
                            }
                        } else {
                            //prize and desc doesnt have more than 2 lines
                            view.privateVars.items[itemId].showDesc = descModuleExist;
                            view.privateVars.items[itemId].showFullDesc = descModuleExist;
                            view.privateVars.items[itemId].showPrize = prizeModuleExist;
                            view.privateVars.items[itemId].showFullPrize = prizeModuleExist;

                            //if there is desc module and we have desc and prize modules each one line then strip dots from prize.
                            if(descModuleExist && prizeModuleExist && tvItemContentPrizeClsHandler.html().slice(-3) === '...') {
                                tvItemContentPrizeClsHandler.html(tvItemContentPrizeClsHandler.html().slice(0, -3));
                            }
                        }

                    } else {
                        //we dont have space to show whole desc and prize
                        let isDescFull = false;
                        let prizesLines = 0;

                        tvItemContentPrizeClsHandler.css({ display: 'none'});
                        tvItemContentDescClsHandler.css({ display: 'none'});

                        //if prize module exist
                        if(prizeModuleExist) {
                            tvItemContentPrizeClsHandler.css({ display: 'block'});

                            const prizeTxt = tvItemContentPrizeClsHandler.html();
                            const renderedPrizeLines = view.methods.truncateTxtToLines(2, prizeTxt,
                                view.publicVars.cssId.tvItemContentPrizeCls, baseTxtHeight, item);

                            container.msg(name + ' rendered prize lines: ' + renderedPrizeLines.lines);

                            prizesLines = renderedPrizeLines.lines;

                            view.privateVars.items[itemId].showPrize = true;
                            view.privateVars.items[itemId].showFullPrize = renderedPrizeLines.full;

                            //if rendered prize 2 lines are more than we have space
                            if(tvItemContentClsHandler.outerHeight() > availableHeightSpace) {
                                //render one line of desc prize
                                view.methods.truncateTxtToLines(1, prizeTxt,
                                    view.publicVars.cssId.tvItemContentPrizeCls, baseTxtHeight, item);

                                prizesLines = 1;
                                view.privateVars.items[itemId].showFullPrize = false;

                                //no additional desc would be rendered
                                isDescFull = true;
                            } else {
                                //if rendered prize desc is equal to 2 then desc wont be showed
                                isDescFull = prizesLines !== 1;
                            }
                        }

                        //if desc module exists and prize didnt take 2 lines
                        if(descModuleExist && !isDescFull) {
                            tvItemContentDescClsHandler.css({ display: 'block'});

                            const descTxt = tvItemContentDescClsHandler.html();

                            //prize desc equals 0 lines so we can show 2 lines of desc
                            if(prizesLines === 0) {
                                const renderedDescLines = view.methods.truncateTxtToLines(2, descTxt,
                                    view.publicVars.cssId.tvItemContentDescCls, baseTxtHeight, item);

                                view.privateVars.items[itemId].showDesc = true;
                                view.privateVars.items[itemId].showFullDesc = renderedDescLines.full;

                                //if 2 lines of desc is more than we have space
                                if(tvItemContentClsHandler.outerHeight() > availableHeightSpace) {
                                    //then render one line of desc
                                    view.methods.truncateTxtToLines(1, descTxt,
                                        view.publicVars.cssId.tvItemContentDescCls, baseTxtHeight, item);

                                    //we have more than one line of desc but only one is showed so fullDesc equals false
                                    view.privateVars.items[itemId].showDesc = true;
                                    view.privateVars.items[itemId].showFullDesc = false;
                                }

                            } else {
                                //prize line takes 1 line so desc can't be grater than 1 line
                                const renderedDescLines = view.methods.truncateTxtToLines(1, descTxt,
                                    view.publicVars.cssId.tvItemContentDescCls, baseTxtHeight, item);

                                //check if we can render one line of desc
                                if(tvItemContentClsHandler.outerHeight() > availableHeightSpace) {
                                    //there is one line of prize and one line of desc won't fit so display to none desc.
                                    tvItemContentDescClsHandler.css({ display: 'none'});
                                    view.privateVars.items[itemId].showDesc = false;
                                    view.privateVars.items[itemId].showFullDesc = false;
                                } else {
                                    //desc one line is showed
                                    view.privateVars.items[itemId].showDesc = true;
                                    if(renderedDescLines.full) {
                                        view.privateVars.items[itemId].showFullDesc = true;
                                    } else {
                                        view.privateVars.items[itemId].showFullDesc = false;
                                    }
                                }



                            }
                        }
                    }

                    if(prizeModuleExist) {
                        //if show desc is true and prize has dots at the end = clear them
                        if(view.privateVars.items[itemId].showDesc === true && tvItemContentPrizeClsHandler.html().slice(-3) === '...') {
                            tvItemContentPrizeClsHandler.html(tvItemContentPrizeClsHandler.html().slice(0, -3));
                        }
                        //replace 4 dots with three
                        tvItemContentPrizeClsHandler.html(tvItemContentPrizeClsHandler.html().replace(/\.\.\.\./g, '...'));
                    }

                    if(descModuleExist) {
                        //replace 4 dots with three
                        tvItemContentDescClsHandler.html(tvItemContentDescClsHandler.html().replace(/\.\.\.\./g, '...'));
                    }

                },

                calculateWindowWidthHeight: () => {
                    view.privateVars.window.windowWidth = $(window).width();
                    view.privateVars.window.windowHeight = $(window).height();
                },

                calculateLineWordNumbers: () => {
                    view.privateVars.oneLineWordNumber = 5;
                    view.privateVars.twoLinesWordNumber = 10;

                    const windowWidth = view.privateVars.window.windowWidth;

                    if(windowWidth >= 950) {
                        view.privateVars.oneLineWordNumber = 8;
                        view.privateVars.twoLinesWordNumber = 16;
                    } else if(windowWidth >= 850) {
                        view.privateVars.oneLineWordNumber = 7;
                        view.privateVars.twoLinesWordNumber = 14;
                    } else if(windowWidth >= 650) {
                        view.privateVars.oneLineWordNumber = 6;
                        view.privateVars.twoLinesWordNumber = 12;
                    } else if(windowWidth >= 600) {
                        view.privateVars.oneLineWordNumber = 5;
                        view.privateVars.twoLinesWordNumber = 10;
                    } else if(windowWidth >= 550) {
                        view.privateVars.oneLineWordNumber = 10;
                        view.privateVars.twoLinesWordNumber = 20;
                    } else if(windowWidth >= 500) {
                        view.privateVars.oneLineWordNumber = 8;
                        view.privateVars.twoLinesWordNumber = 16;
                    } else if(windowWidth >= 450) {
                        view.privateVars.oneLineWordNumber = 7;
                        view.privateVars.twoLinesWordNumber = 14;
                    } else if(windowWidth >= 425) {
                        view.privateVars.oneLineWordNumber = 6;
                        view.privateVars.twoLinesWordNumber = 12;
                    } else if(windowWidth >= 375) {
                        view.privateVars.oneLineWordNumber = 5;
                        view.privateVars.twoLinesWordNumber = 10;
                    } else if(windowWidth >= 320) {
                        view.privateVars.oneLineWordNumber = 4;
                        view.privateVars.twoLinesWordNumber = 8;
                    }
                },

                truncateTxtToLines: (count, txt, handler, baseTxtHeight, item) => {
                    
                    const splitArr = txt.split(' ');
                    let startArr = [];
                    let leftArr = [];
                    let wordAccepted = [];

                    const itemHandler = $(handler, item);

                    itemHandler.html('');

                    if(splitArr.length > 0) {
                        if(count === 2) {
                            startArr = splitArr.slice(0, view.privateVars.twoLinesWordNumber);
                            leftArr = splitArr.slice(view.privateVars.twoLinesWordNumber);
                        } else {
                            startArr = splitArr.slice(0, view.privateVars.oneLineWordNumber);
                            leftArr = splitArr.slice(view.privateVars.oneLineWordNumber);
                        }

                        let stopForFlag = false;

                        let currentTxt = $.trim(startArr.join(' '));

                        itemHandler.html(currentTxt + '...');

                        wordAccepted = startArr;

                        if(itemHandler.outerHeight().toFixed(2) > (count * baseTxtHeight).toFixed(2)) {
                            startArr.forEach((word) => {

                                if(stopForFlag) {
                                    return;
                                }

                                wordAccepted.pop();
                                let currentTxt = $.trim(wordAccepted.join(' '));

                                itemHandler.html(currentTxt + '...');

                                if(itemHandler.outerHeight().toFixed(2) <= (count * baseTxtHeight).toFixed(2)) {
                                    itemHandler.html($.trim(wordAccepted.join(' ')) + '...');
                                    stopForFlag = true;
                                }
                            });
                        } else {

                            leftArr.forEach((word) => {

                                if(stopForFlag) {
                                    return;
                                }

                                wordAccepted.push(word);
                                let currentTxt = $.trim(wordAccepted.join(' '));

                                itemHandler.html(currentTxt + '...');

                                if(itemHandler.outerHeight().toFixed(2) > (count * baseTxtHeight).toFixed(2)) {
                                    wordAccepted.pop();
                                    itemHandler.html($.trim(wordAccepted.join(' ')) + '...');
                                    stopForFlag = true;
                                }
                            });
                        }
                    }

                    if(splitArr.length === wordAccepted.length && itemHandler.html().slice(-3) === '...') {
                        itemHandler.html(itemHandler.html().slice(0, -3));
                    }

                    if(itemHandler.outerHeight().toFixed(2) === (count * baseTxtHeight).toFixed(2)) {
                        return {
                            lines: count,
                            full: splitArr.length === wordAccepted.length
                        };
                    } else {
                        return {
                            lines: parseInt(itemHandler.outerHeight().toFixed(2) / baseTxtHeight.toFixed(2)),
                            full: splitArr.length === wordAccepted.length
                        }
                    }

                    // console.log(txt);
                    //
                    // console.log(count);
                    // console.log(handler);
                    // console.log(baseTxtHeight);
                    // console.log($(item).html());
                },

                showTvSchedule: () => {

                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();

                    $(view.publicVars.cssId.tvItemListGuardCls).css({ visibility: 'hidden' });

                    $(view.publicVars.cssId.tvItemListContainerCls).css({ height: 'auto', overflow: 'auto'});

                    $(view.publicVars.cssId.tvItemListLoaderId).transit({ opacity: 0}, 300, () => {
                        $(view.publicVars.cssId.tvItemListLoaderId).css({ display: 'none', opacity: 1});
                    });

                    backTop.enable();

                    $(view.publicVars.cssId.tvItemListInnerCls).css({ display: 'block', opacity: 0 });
                    $(view.publicVars.cssId.tvItemListInnerCls).transit({ opacity: 1 }, 300, () => {
                        view.privateVars.loading = false;
                        view.privateVars.changeSizeLoading = false;
                        view.privateVars.calculatingItemsFlag = false;
                        container.msg(name + ': showed t ' + (Date.now() - view.privateVars.currentTimeStamp));
                    });

                    if($(view.publicVars.cssId.tvItemInnerCls + view.publicVars.cssId.isActiveCls).length > 0) {
                        jump.centerTo(view.publicVars.cssId.tvItemInnerCls + view.publicVars.cssId.isActiveCls, null, {
                            speed: 500,
                            modifier: - parseInt(headerHeight)
                        });
                    } else {
                        jump.jumpTo(view.publicVars.cssId.tvItemListInnerCls, {
                            speed: 0,
                            modifier: - parseInt(headerHeight)
                        });
                    }
                },

                loadNewDate: (id, day, month, year) => {
                    const oldHeight = $(view.publicVars.cssId.tvItemListContainerCls).outerHeight();
                    const headerHeight = $(view.publicVars.cssId.headerCls).outerHeight();
                    const newWindowHeight = view.privateVars.window.windowHeight - headerHeight;
                    let newHeight = oldHeight;

                    if(newHeight > newWindowHeight) {
                        newHeight = newWindowHeight;
                    }

                    if(newHeight % 2 === 1) {
                        newHeight = newHeight + 1;
                    }

                    $(view.publicVars.cssId.tvItemListInnerCls).transit({opacity: 0}, 300, function () {});

                    $(view.publicVars.cssId.tvItemListGuardCls).css({ visibility: 'visible' });

                    $(view.publicVars.cssId.tvItemListContainerCls).css({ height: newHeight + 'px', overflow: 'hidden'});

                    $(view.publicVars.cssId.tvItemListInnerCls).html('');

                    $(view.publicVars.cssId.tvItemListLoaderId).css({opacity: 0, display: 'block'});
                    $(view.publicVars.cssId.tvItemListLoaderId).transit({opacity: 1});

                    backTop.disable();

                    jump.centerTo(view.publicVars.cssId.tvItemListLoaderId, () => {
                        model.methods.getScheduleForDate(day,month,year);
                    }, {
                        modifier: - parseInt(headerHeight)
                    });

                },

                actionShowNewTvSchedule: (action, data) => {

                    const compiled = _.template($(view.publicVars.cssId.templateId).html());

                    const output = compiled({
                        data: data
                    });

                    if(data.items.length > 0) {
                        $(view.publicVars.cssId.dayTimeSelectorItem).removeClass(view.publicVars.cssId.isInactiveCls.substr(1));
                    }

                    $(view.publicVars.cssId.tvItemListInnerCls).html(output);

                    let bulkNewImgPreload = [];

                    for(const property in data.items_images) {
                        bulkNewImgPreload.push(data.items_images[property]);
                    }

                    preloader.setPreloadBulk('tv_program_images' + data.date, bulkNewImgPreload);

                    preloader.getPreloadBulkFinished('tv_program_images' + data.date, () => {
                        view.methods.recalculateOpenState();
                    });
                },

                calendar: {
                    handleDayChosed: (handler) => {
                        if(view.privateVars.calendar.loading) {
                            return;
                        }

                        view.privateVars.calendar.loading = true;

                        const day = container.getData($(handler)[0], 'day');
                        const month = container.getData($(handler)[0], 'month');
                        const year = container.getData($(handler)[0], 'year');
                        const set = container.getData($(handler)[0], 'set');
                        const id = container.getData($(handler)[0], 'id');

                        view.privateVars.currentItem = {
                            id: id,
                            day: parseInt(day),
                            month: parseInt(month),
                            year: parseInt(year)
                        };

                        slider.setCurrentSet(set);

                        $(view.publicVars.cssId.calendar.calendarLightboxItemCls).removeClass(view.publicVars.cssId.calendar.isActiveCls.substr(1));
                        $(handler).addClass(view.publicVars.cssId.calendar.isActiveCls.substr(1));

                        $(view.publicVars.cssId.weekCarousel.weekCarouselItemCls).removeClass(view.publicVars.cssId.weekCarousel.isActiveCls.substr(1));
                        $(view.publicVars.cssId.weekCarousel.weekCarouselItemCls + id).addClass(view.publicVars.cssId.weekCarousel.isActiveCls.substr(1));

                        view.methods.loadNewDate(id, day, month, year);

                        lightbox.close();
                    },

                    onLightboxClose: () => {
                        view.privateVars.calendar.loading = false;
                    },

                    handleLightboxState: () => {
                        const windowWidth = view.privateVars.window.windowWidth;
                        const windowHeight = view.privateVars.window.windowHeight;

                        if(windowWidth < 600 && lightbox.getStatus()) {
                            lightbox.close();
                        }

                        if(windowHeight < 390) {
                            lightbox.close();
                        }
                    }
                },

                weekCarousel: {
                    handleDayChosed: (handler) => {

                        if($(handler).hasClass(view.publicVars.cssId.weekCarousel.isEmptyCls.substr(1))) {
                            return;
                        }

                        const id = container.getData($(handler)[0], 'id');
                        const day = container.getData($(handler)[0], 'day');
                        const month = container.getData($(handler)[0], 'month');
                        const year = container.getData($(handler)[0], 'year');

                        view.privateVars.currentItem = {
                            id: id,
                            day: parseInt(day),
                            month: parseInt(month),
                            year: parseInt(year)
                        };

                        $(view.publicVars.cssId.calendar.calendarLightboxItemCls).removeClass(view.publicVars.cssId.calendar.isActiveCls.substr(1));
                        $('#' + view.publicVars.cssId.calendar.calendarLightboxItemCls.substr(1) + id).addClass(view.publicVars.cssId.calendar.isActiveCls.substr(1));

                        $(view.publicVars.cssId.weekCarousel.weekCarouselItemCls).removeClass(view.publicVars.cssId.weekCarousel.isActiveCls.substr(1));
                        $(handler).addClass(view.publicVars.cssId.weekCarousel.isActiveCls.substr(1));

                        view.methods.loadNewDate(id, day, month, year);
                    },


                    decorateSliderElement: (elem) => {
                        const id = parseInt(container.getData(elem[0], 'id'));

                        if (id === parseInt(view.privateVars.currentItem.id)) {
                            $(view.publicVars.cssId.weekCarousel.weekCarouselItemCls, elem).addClass(view.publicVars.cssId.weekCarousel.isActiveCls.substr(1));
                        } else {
                            $(view.publicVars.cssId.weekCarousel.weekCarouselItemCls, elem).removeClass(view.publicVars.cssId.weekCarousel.isActiveCls.substr(1));
                        }

                        return elem;
                    },

                    beforeSlideCallback: (handler) => {
                        handler.fadeOut();
                        // handler.removeClass('bounceIn');
                        // handler.addClass('zoomOut');
                    },
                }
            };

            /* custom events */
            pubSub.subscribe('view/actionShowNewTvSchedule', view.methods.actionShowNewTvSchedule);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                    slider.init(options.sliderSetup);
                    slider.setElementDecorateCallback(view.methods.weekCarousel.decorateSliderElement);
                    slider.setCallback('beforeSlide', view.methods.weekCarousel.beforeSlideCallback);

                    lightbox.init(options.lightboxSetup);
                    lightbox.setCloseCallback(view.methods.calendar.onLightboxClose);

                    backTop.init(options.backTopSetup);
                }
            };


        })();

    });
